/* eslint-disable camelcase */
export function signInRequest(user_id, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { user_id, password },
  };
}

export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}
